export default __webpack_public_path__ + "static/media/closedCardHorizontal.d0147b9f.png";